





















































































































































































































































































































































import { apiOrderOrderDeliverDetail } from '@/api'
import { computed } from '@vue/composition-api'
import { copyTextToClipboard, padStart, wait } from 'vtils'
import { dcb } from '@dcb/jssdk'
import {
  defineClassComponent,
  useApiPlus,
  useHandler,
  useQuery,
} from '@/hooks'
import { InstantDeliveryComponents } from './components'
import { navigateBack, navigateTo } from '@/router'
import { submit, Track } from '@/utils'
import { Toast } from 'vant'

export default defineClassComponent(
  {
    components: InstantDeliveryComponents,
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '订单详情',
        }))
      }

      loading = computed(() => this.apiData.loading)

      query = useQuery<{
        orderNo: string
      }>()

      padLeft = (text: string) => {
        return padStart(text, 2, '0')
      }

      apiData = useApiPlus(
        {
          orderData: () =>
            apiOrderOrderDeliverDetail({
              orderNo: this.query.orderNo,
            }),
        },
        {
          refreshOnActivated: true,
        },
      )

      statusIconMap = {
        0: require('./images/detail/待支付.png'),
        901: require('./images/detail/已关闭.png'),
        100: require('./images/detail/待发货.png'),
        102: require('./images/detail/已发货.png'),
        101: require('./images/detail/已发货.png'),
        900: require('./images/detail/已完成.png'),
        902: require('./images/detail/已完成.png'),
      }

      order = computed(() => this.apiData.data.orderData)

      handleServiceClick = useHandler<
        | '商品'
        | '倒计时结束'
        | '刷新'
        | '联系配送人员'
        | '复制订单号'
        | '联系商家'
        | '平台客服'
        | '发票'
      >({
        商品: (goodsId: string) => {
          navigateTo('InstantDeliveryGoodsIndex', {
            goodsId,
          })
        },
        倒计时结束: (seconds: number) => {
          if (seconds !== 0) {
            submit(async $ => {
              $.start()
              await wait(1000)
              this.apiData.refresh()
            })
          }
        },
        刷新: (trigger?: 'delete') => {
          if (trigger === 'delete') {
            navigateBack()
          } else {
            submit(async $ => {
              $.start()
              await wait(1000)
              this.apiData.refresh()
            })
          }
        },
        联系配送人员: () => {
          dcb.makePhoneCall({
            phoneNumber: this.order.value.deliverUser!.serviceUserTel!,
          })
        },
        复制订单号: () => {
          copyTextToClipboard(this.order.value.orderNo!)
          Toast.success('复制成功')
        },
        联系商家: () => {
          dcb.makePhoneCall({
            phoneNumber: this.order.value.merchantTel!,
          })
        },
        平台客服: () => {
          dcb.makeCustomerServicePhoneCall()
        },
        发票: () => {
          if (this.order.value.invoiceStatus === -1) {
            dcb.makePhoneCall({
              phoneNumber: '4009008799',
            })
          } else if (this.order.value.invoiceStatus === 2) {
            navigateTo('InvoiceDetail', {
              orderNo: this.query.orderNo,
            })
          } else {
            navigateTo('InvoiceRequest', {
              orderNo: this.query.orderNo,
            })
          }
        },
      })
    },
)
